function anchorScrollTo(e) {
  e.preventDefault();
  let target = document.querySelector(e.currentTarget.getAttribute('href'));
  if(target) {
    target.scrollIntoView({
      behavior: 'smooth',
    });
  }
}
